<template>
  <div class="container-fluid">
    <div class="alert alert-danger alert-margin" role="alert" v-if="isMessage">
      {{ message }}
    </div>
    <div id="title" class="row">
      <div class="col-1">
        <svg
          id="header"
          class="bd-placeholder-img mr-2 rounded"
          width="28"
          height="28"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="xMidYMid slice"
          focusable="false"
          role="img"
          aria-label="Placeholder: 32x32"
        >
          <rect width="100%" height="100%" fill="#00C3E0"></rect>
        </svg>
      </div>
      <div class="col-5">
        <h5>{{ pageTitle }}</h5>
      </div>
      <div class="col-3">
        <button
          id="backBtn"
          type="button"
          class="btn-sm btn-outline-info"
          v-on:click="back"
        >
          キャンセルする
        </button>
      </div>
    </div>
    <div id="register_form" class="row">
      <div class="col-1"></div>
      <div class="col-8">
        <div class="form-group">
          <div class="row" style="height: 130px">
            <div class="col-2">
              <label>イメージ</label>
            </div>
            <div class="col-2">
              <img class="card-img" src="/card-image.svg" v-show="!preview" />
              <div
                class="trim-circle"
                :style="{ backgroundImage: 'url(' + preview + ')' }"
                id="imageContainer"
                v-show="preview"
              ></div>
            </div>
            <div class="col-1"></div>
            <div class="col-6">
              <form enctype="multipart/form-data" @submit.prevent="upload">
                <div class="row">
                  <div id="fileInputContainer">
                    <label class="fileUploadBtn" tabindex="0"
                      >ファイルを選択
                      <input
                        id="inputtag"
                        type="file"
                        accept="image/png, image/jpeg, image/svg+xml"
                        ref="file"
                        v-on:change="selectedFile"
                      />
                    </label>
                  </div>
                </div>
                <div class="row">
                  <div id="fileInputLabel">{{ fileLabel }}</div>
                </div>
                <div class="row">
                  <div>
                    <button class="btn btn-info setting-button-margin btn-sm">
                      登録
                    </button>
                  </div>
                  <div
                    class="alert alert-danger alert-margin small"
                    role="alert"
                    style="margin: 0.5rem; padding: 0.25rem"
                    v-show="isUploadFile"
                  >
                    登録ボタンを押してください
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { sessions } from '../../mixin/session';
import { path } from '../../mixin/path';
import { headers } from '../../mixin/headers';

export default {
  name: 'Create',
  mixins: [sessions, path, headers],
  props: ['realms', 'serviceName'],
  data: function () {
    return {
      message: '',
      uploadFile: null,
      imagePath: null,
      preview: null,
      fileLabel: 'ファイルが選択されていません'
    };
  },
  computed: {
    isMessage: function () {
      return this.message.length > 0;
    },
    isUploadFile: function () {
      return this.uploadFile !== null;
    },
    pageTitle: function () {
      return 'アイコン 追加';
    }
  },
  methods: {
    back() {
      this.$router.replace(
        this.replacePath(this.$cognito, this.realms, '/common/icon/index')
      );
    },
    selectedFile(event) {
      let files = event.target.files;
      if (files.length > 0) {
        this.uploadFile = files[0];
        const reader = new FileReader();
        reader.onload = () => {
          this.preview = reader.result;
        };
        reader.readAsDataURL(this.uploadFile);
        this.fileLabel = this.uploadFile.name;
      }
    },
    upload() {
      this.message = '';
      if (this.uploadFile === null) {
        alert('ファイルが指定されていません。');
        return;
      }
      var blob = new Blob([this.uploadFile], {
        type: 'application/octet-stream'
      });
      var hospitalId = this.$store.getters.hospital.id;
      var hospitalCode = this.$store.getters.hospital.code;
      this.$cognito
        .isAuthenticated()
        .then((session) => {
          if (session) {
            var accessToken = this.getAccessToken(this.$cognito, session);
            axios
              .post(
                `/api/icon/management/${hospitalId}/${hospitalCode}/icons/${this.uploadFile.name}`,
                blob,
                {
                  headers: this.headersUploadStream(accessToken)
                }
              )
              .then((response) => {
                if (response !== undefined && response['errorMessage']) {
                  this.message = response['errorMessage'];
                } else {
                  alert('イメージをアップロードしました。');
                  this.back();
                }
              })
              .catch((err) => {
                this.message = err.response.data.errorMessage;
              });
          }
        })
        .catch((err) => {
          this.message = err.message;
        });
    }
  }
};
</script>

<style scoped>
#header {
  float: right;
}
#title {
  padding: 10px;
}
.alert-margin {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.card-img {
  width: 160px;
  height: 160px;
  border: 2px #007bff solid;
}
.trim-circle {
  width: 160px;
  height: 160px;
  border: 2px #007bff solid;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 100% auto;
}
.setting-button-margin {
  margin-top: 0.5rem;
}
.fileUploadBtn {
  border: 1px solid #000000;
  border-radius: 0.25rem;
  display: inline-block;
  padding: 0.1rem 0.4rem;
  margin: 0.5em 0;
  background: #efefef;
  color: #000000;
  position: relative;
}
.fileUploadBtn:hover,
.fileUploadBtn:focus {
  background: #b7b4b4;
  filter: brightness(1.2);
}
#fileInputLabel {
  top: 100%;
  left: 0;
  pointer-events: none;
}
#inputtag {
  position: absolute;
  opacity: 0;
  top: 0;
  left: 0;
  width: 100%;
}
</style>
